import { UtilsService } from '@abp/utils/utils.service';
import { AppConsts } from '@shared/AppConsts';
import { AppPreBootstrap } from 'AppPreBootstrap';

export class SignalRHelper {
    static initSignalR(callback: () => void): void {

        var encryptedAuthToken = AppPreBootstrap.getTokenLocalstorage(AppConsts.authorization.encrptedAuthTokenName);
        abp.signalr = {
            autoConnect: true,
            connect: undefined,
            hubs: undefined,
            qs: AppConsts.authorization.encrptedAuthTokenName + "=" + encodeURIComponent(encryptedAuthToken),
            remoteServiceBaseUrl: AppConsts.remoteServiceBaseUrl,
            startConnection: undefined,
            url: '/signalr'
        };

        jQuery.getScript(AppConsts.appBaseUrl + '/assets/abp/abp.signalr-client.js', () => {
            callback();
        });
    }
}
